import App from './App.vue';

export default {
  path: '/CDS_VF_HeliportList',
  name: 'CDS_VF_HeliportList',
  component: App,
  meta: {
    pageProperty: {
      title: 'ヘリポート一覧',
      controller: 'CDS_CTR_HeliportList',
    },
  },
};
